<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.match_result")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-3.mb-1
                DatePicker(@update="submit" :singleDatePicker="true")
                //- DateRangePicker(:value="dateRange" :singleDatePicker="true" :ranges="false")
              .col-sm-12.col-md-6.col-lg-6.col-xl-3.mb-1
                b-input-group(:prepend="$t('ui.game_type')" size="sm")
                  b-form-select(
                    ref="game_type"
                    v-model="game_type"
                    size="sm"
                    :options="renderGameType()"
                    @change="changeGameType"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-3.mb-1
                b-input-group(:prepend="$t('ui.league')" size="sm")
                  b-form-select(
                    ref="league"
                    v-model="league"
                    size="sm"
                    :options="renderLeague()"
                    @change="submit"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
            b-row
              //- .col-sm-12.col-md-8.col-lg-9.col-xl-10
              //-   b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="submit")
              //- .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-2
              //-   b-input-group(:prepend="$t('ui.page_size')" size="sm")
              //-     b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-10.col-xl-10
                .table-sm.table-responsive
                  table#tblList.table.table-hover.table-bordered
                    thead
                      tr
                        th.align-middle.text-left.bg-grey-lighter(style="width:10%;") {{ $t("ui.date_time") }}
                        th.align-middle.text-center.bg-grey-lighter {{ $t("ui.event") }}
                        template(v-if="!isOutright()")
                          th.align-middle.text-center.bg-grey-lighter(style="width:14%;") {{ $t("ui.first_half") }}
                          th.align-middle.text-center.bg-grey-lighter(style="width:14%;") {{ $t("ui.full_time") }}
                        template(v-else)
                          th.align-middle.text-center.bg-grey-lighter(style="width:28%;") {{ $t("ui.winner") }}
                    tbody
                      template(v-if="filterLeague()")
                        template(v-for="(league,index) in filterLeague()" :keys="index")
                          tr
                            td.bg-grey-transparent-2(colspan=7) #[b {{ getName(league, 0) }}]
                          template(v-for="(match,index) in filterMatch(league)" :keys="index")
                            tr
                              td.align-middle.text-center {{ $moment(match.match_time).format("YYYY-MM-DD HH:mm:ss") }}
                              template(v-if="!isOutright()")
                                td.align-middle
                                  table(style="width:100%;")
                                    tr
                                      td.align-middle.text-right(style="width:48%;border:none;")
                                        span.mr-1.badge.badge-yellow.text-dark(v-if="match.FLG == 1") F
                                        span.mr-1.badge.badge-green.text-bright(v-if="match.FLGH == 1") L
                                        span {{ getName(match.match_id, 1) }}
                                      td.align-middle.text-center.text-danger.f-w-700(style="width:4%;border:none;") VS
                                      td.align-middle.text-left(style="width:48%;border:none;")
                                        span.mr-1 {{ getName(match.match_id, 2) }}
                                        span.mr-1.badge.badge-yellow.text-dark(v-if="match.FLG == 2") F
                                        span.badge.badge-green.text-bright(v-if="match.FLGH == 2") L
                              template(v-else)
                                td.align-middle.text-center {{ match.home_name_en }}
                              template(v-if="!isOutright()")
                                td.align-middle.text-center
                                  template(v-if="match.half_match_status == 1")
                                    span {{ match.half_home }} - {{ match.half_away }}
                                  template(v-else)
                                    span.text-danger.f-w-700 {{ getMatchStatus(match.half_match_status) }}
                                td.align-middle.text-center
                                  template(v-if="match.match_status == 1")
                                    span {{ match.final_home }} - {{ match.final_away }}
                                  template(v-else)
                                    span.text-danger.f-w-700 {{ getMatchStatus(match.match_status) }}
                              template(v-else)
                                td.align-middle.text-center
                                  span {{ (match.outright_teamwin) ? (match.outright_teamwin == 0) ? $t("ui.lose") : $t("ui.win") : "-" }}

</template>

<script>
import config from "@/config";
import { required } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker";
import DatePicker from "@/library/DatePicker.vue";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    DateRangePicker,
    DatePicker
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      game_type: "1,false,false",
      gameTypeList: [],
      league: 0,
      matchResult: [],
      filter: null,
      sortBy: "match_time",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      match: [],
      league1: []
    };
  },
  validations: {
    member_id: {
      required
    }
  },
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    },
    fields() {
      return [
        {
          key: "match_time",
          label: this.$t("ui.date_time"),
          sortable: true,
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "league_name",
          label: this.$t("ui.league_name"),
          sortable: true,
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "half_time",
          label: this.$t("ui.half_time"),
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "5%"
          }
        },
        {
          key: "full_time",
          label: this.$t("ui.full_time"),
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "5%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    language() {
      if(this.$store.getters.language == "zh") {
        return "cn"
      } else {
        return this.$store.getters.language
      }
    }
  },
  mounted: function() {
    this.$store.dispatch("user/getGameTypeLookup")
    this.submit()
  },
  methods: {
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.getMatchResult()
      this.getLeagueLookup()
    },
    isOutright: function() {
      if(this.game_type) {
        return this.game_type.split(",")[2] == "true"
      }
    },
    filterLeague: function() {
      if(this.matchResult.length > 0) {
        return this.matchResult.map(item => item.league_id).filter((value, index, self) => self.indexOf(value) === index)
      }
    },
    filterMatch: function(league) {
      if(this.matchResult.length > 0) {
        return this.matchResult.filter((value, index, self) => value.league_id == league)
      }
    },
    getMatchStatus: function(status) {
      switch(status) {
        case 0:
          return "-" //this.$t("ui.live").toUpperCase()
        case 2:
          return this.$t("ui.cancel").toUpperCase()
        case 3:
          return this.$t("ui.refund").toUpperCase()
        case 4:
          return this.$t("ui.edited").toUpperCase()
        case 5:
          return this.$t("ui.suspend").toUpperCase()
      }
    },
    getName: function(id, mode) {
      let name = ""
      if(mode == 0) {
        this.league1.forEach(x => {
          if(x.league_id == id) {
            name = (x["name_" + this.language]) ? x["name_" + this.language] : x["name_en"]
          }
        })
      } else {
        this.match.forEach(y => {
          if(y.match_id == id) {
            if (mode == 1) {
              name = (y["home_name_" + this.language]) ? y["home_name_" + this.language] : y["home_name_en"]
            } else {
              name = (y["away_name_" + this.language]) ? y["away_name_" + this.language] : y["away_name_en"]
            }
          }
        })
      }
      return name
    },
    changeGameType: function() {
      this.league = 0
      this.submit()
    },
    getMatchResult: function() {
      let working_date = this.dateRange.startDate
      let game_type = parseInt(this.game_type.split(",")[0])
      let league_id = this.league
      this.loading = true
      this.$store
        .dispatch("user/getMatchResult", { working_date, game_type, league_id })
        .then(response => {
          this.matchResult = []
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if (this.submission.success == true) {
            if(response.data.length > 0) {
              this.matchResult = response.data
              this.match = response.names.match
              this.league1 = response.names.league
            } else {
              this.matchResult = []
              this.match = []
              this.league1 = []
            }
          } else {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
          }
        })
        .catch(response => {
          this.loading = false
          this.matchResult = []
          this.match = []
          this.league1 = []
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });

    },
    renderGameType: function() {
      let x = this.$store.getters.getGameTypeLookUp
      let z = []
      x.forEach(y => {
        z.push({
          value: y.game_type + "," + y.ft_only + "," + y.is_outright,
          text: (y["name_" + this.language]) ? y["name_" + this.language] : y["name_en"]
        })
      })
      return z
    },
    renderLeague: function() {
      let x = this.$store.getters.getLeagueLookUp
      let z = [{value:0, text:this.$t("ui.all")}]
      x.forEach(y => {
        z.push({
          value: y.league_id,
          text: (y["name_" + this.language]) ? y["name_" + this.language] : y["league_name"]
        })
      })
      return z
    },
    getLeagueLookup: function() {
      let working_date = this.dateRange.startDate
      let game_type = parseInt(this.game_type.split(",")[0])
      this.$store.dispatch("user/getLeagueLookup", { working_date, game_type })
    }
  }
};
</script>